import { useEffect } from 'react';
export var useTrackTitle = function useTrackTitle(title, onChange) {
  useEffect(function () {
    var _document2;
    // Подписываемся на изменение заголовка
    var observer = new MutationObserver(function () {
      var _document;
      if (!((_document = document) !== null && _document !== void 0 && _document.title.includes(title))) {
        onChange(document.title);
      }
    });
    var target = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.querySelector('title');
    if (target) {
      observer.observe(target, {
        childList: true
      });
    }
    return function () {
      observer.disconnect();
    };
  }, []);
};